import React from 'react';
import { Button } from '@infoods/lifebase-ui';

import classes from './ChallengeBanner.module.scss';
import challengeBannerImage from '../../../../../shared/assets/image/banners/img-banner-challenge.png';
import { ClosestChallenge } from '../../../../interfaces/ClosestChallenge';
import { useChallengeBannerContent } from './hooks/useChallengeBannerContent';

type ChallengeBannerProps = {
  closestChallenge: ClosestChallenge | null;
};

const ChallengeBanner = ({ closestChallenge }: ChallengeBannerProps) => {
  const {
    title,
    description,
    primaryActionLabel,
    secondaryActionLabel,
    onPrimaryAction,
    onSecondaryAction,
  } = useChallengeBannerContent(closestChallenge);

  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <div>
          <h1 className={classes.title}>{title}</h1>
          <p className={classes.description}>{description}</p>
        </div>
        <div className={classes.buttonsContainer}>
          <Button variant="contained" size="small" onClick={onPrimaryAction}>
            {primaryActionLabel}
          </Button>
          <Button
            variant="outlined"
            size="small"
            className="wightBg"
            onClick={onSecondaryAction}
          >
            {secondaryActionLabel}
          </Button>
        </div>
      </div>
      <div className={classes.imageContainer}>
        <img src={challengeBannerImage} alt="challenge-banner-image" />
      </div>
    </div>
  );
};

export { ChallengeBanner };
